import { IScenarioModel } from '../reducers/ScenariosReducers';

export const MODELS: IScenarioModel[] = Array(20).fill({
  name: 'Test',
  risk: 4,
});
